import { StyleSheet } from 'react-native'
import { ThemedValues } from 'styles/themed'

export const ThemedListStyles = StyleSheet.create({
	listContainer: {
		paddingLeft: ThemedValues.marginHorizontal
	},
})
